import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import TaxCalculationTabContent from './TaxCalculationTabContent';
import { fetchGTDLogs, fetchGetReqsResp } from 'redux/logs/LogActions';

const mapStateToProps = ({ logs }) => ({
  gtdLogs: logs.gtdLogs,
  gtdLogInformation: logs.gtdLogInformation,
  fetchingGTDLogs: logs.fetchingGTDLogs,
  fetchingSelectedLogInformation: logs.fetchingSelectedLogInformation
});

const mapDispatchToProps = dispatch => ({
  logActions: bindActionCreators({ fetchGTDLogs, fetchGetReqsResp }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(TaxCalculationTabContent);



// WEBPACK FOOTER //
// ./src/components/viewTransactions/viewTransactionsGrid/c/invoiceLinesSlidingPanel/taxCalculationTabContent/TaxCalculationTabContentConnector.js